import type { NotificationData } from '@mantine/notifications';
import { notifications as mantineNotifications } from '@mantine/notifications';

const NotificationVariantProps = {
  success: {
    color: 'mint',
    title: 'Success!',
  },
  error: {
    color: 'cerise',
    title: 'Error',
  },
  warning: {
    color: 'yellow',
    title: 'Warning!',
  },
  loading: {
    color: 'cobalt',
    loading: true,
  },
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const oldShow = mantineNotifications.show as any;

interface ShowProps extends NotificationData {
  variant?: keyof typeof NotificationVariantProps;
}
const newShow = (props: ShowProps) => {
  let variantProp = {};
  if (props.variant && props.variant in NotificationVariantProps) {
    const confirmedVariant = props.variant as keyof typeof NotificationVariantProps;

    variantProp = { ...NotificationVariantProps[confirmedVariant] };
  }

  return oldShow({
    ...variantProp,
    ...props,
  });
};

const _notifications = () => {};

const notifications = Object.assign(_notifications, { ...mantineNotifications, show: newShow });

export { notifications };
